import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { LinkedInPopUp } from "react-linkedin-login-oauth2";

import Layout from "./components/LayoutComp/";
import Home from "./pages/Home";
import Credentials from "./pages/Credentials";
import Contact from "./pages/Contact";
import Favorites from "./components/FavoritesComp";
import Search from "./pages/Search";
import View from "./pages/View";
import HaveDesk from "./pages/HaveDesk";
import Dashboard from "./pages/Dashboard";
import Reservation from "./pages/Reservation";
import Terms from "./pages/Terms";
import Page404 from "./pages/Page404";

class App extends Component {
  render() {
    return (
      <Layout>
        <BrowserRouter>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/login" component={Credentials} />
            <Route exact path="/signup" component={Credentials} />
            <Route exact path="/verification" component={Credentials} />
            <Route exact path="/verification/:id" component={Credentials} />
            <Route exact path="/lost-password" component={Credentials} />
            <Route exact path="/lost-password/:id" component={Credentials} />
            <Route exact path="/lost-password-link" component={Credentials} />
            <Route exact path="/linkedin" component={LinkedInPopUp} />
            <Route exact path="/contact" component={Contact} />
            <Route exact path="/spaces/favorites" component={Favorites} />
            <Route exact path="/locations/:name" component={Search} />
            <Route exact path="/rent-desk/:name" component={View} />
            <Route exact path="/have-desk/add/:id" component={HaveDesk} />
            <Route exact path="/have-desk/edit/:id" component={HaveDesk} />
            <Route exact path="/dashboard/:page" component={Dashboard} />
            <Route exact path="/reservation/:id" component={Reservation} />
            <Route exact path="/terms" component={Terms} />
            <Route exact component={Page404} />
          </Switch>
        </BrowserRouter>
      </Layout>
    );
  }
}

export default App;
